/* Emporium: endless product carousel.
   The products are repeated before and after the real set; when scrolling settles inside a repeat,
   the carousel silently jumps to the identical spot in the real set. Arrows and swipes never hit an end.
   Works with the theme's own <slider-component>; only carousels marked data-e-loop are affected. */
(function () {
  function setup(comp) {
    if (comp.dataset.eLoopReady) return;
    var slider = comp.querySelector('[id^="Slider-"]');
    if (!slider) return;
    var items = Array.prototype.filter.call(slider.children, function (li) {
      return li.id && li.id.indexOf('Slide-') === 0;
    });
    if (items.length < 2) return;
    comp.dataset.eLoopReady = '1';

    // Keep the theme's arrows enabled at both ends
    comp.enableSliderLooping = true;
    comp.querySelectorAll('.slider-button').forEach(function (b) { b.removeAttribute('disabled'); });

    function makeClone(li) {
      var c = li.cloneNode(true);
      c.removeAttribute('id');
      c.setAttribute('aria-hidden', 'true');
      c.classList.add('e-loop-clone');
      [c].concat(Array.prototype.slice.call(c.querySelectorAll('*'))).forEach(function (el) {
        el.classList && el.classList.remove('scroll-trigger', 'scroll-trigger--offscreen', 'animate--slide-in', 'animate--fade-in');
        if (el.id) el.removeAttribute('id');
        if (el.matches && el.matches('a, button, input, select, textarea')) el.setAttribute('tabindex', '-1');
      });
      return c;
    }

    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();
    items.forEach(function (li) { before.appendChild(makeClone(li)); after.appendChild(makeClone(li)); });
    var firstAfter = after.firstChild;
    slider.insertBefore(before, slider.firstChild);
    slider.appendChild(after);

    function home() { return items[0].offsetLeft - slider.children[0].offsetLeft; } // real set start
    function cycle() { return firstAfter.offsetLeft - items[0].offsetLeft; }          // width of one set

    function jump(left) {
      var prev = slider.style.scrollBehavior;
      slider.style.scrollBehavior = 'auto';
      slider.scrollLeft = left;
      slider.style.scrollBehavior = prev;
    }

    function recentre() {
      var H = home(), W = cycle();
      if (!W) return;
      if (slider.scrollLeft >= H + W - 2) jump(slider.scrollLeft - W);
      else if (slider.scrollLeft < H - 2) jump(slider.scrollLeft + W);
    }

    // Start on the real first product
    jump(home());
    requestAnimationFrame(function () { jump(home()); });

    // Re-centre once scrolling has settled
    var t;
    function settle() { clearTimeout(t); t = setTimeout(recentre, 140); }
    if ('onscrollend' in window) slider.addEventListener('scrollend', recentre);
    slider.addEventListener('scroll', settle, { passive: true });

    // The theme's arrow handler scrolls by one product; make sure there is always room either side
    comp.querySelectorAll('.slider-button').forEach(function (b) {
      b.addEventListener('click', function () { recentre(); }, true);
    });

    // Only re-home when the width changes (mobile browsers fire resize when the address bar hides)
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      clearTimeout(t); t = setTimeout(function () { jump(home()); }, 200);
    });
  }

  function init() {
    document.querySelectorAll('slider-component[data-e-loop]').forEach(function (comp) {
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('slider-component').then(function () { setTimeout(function () { setup(comp); }, 0); });
      } else {
        setup(comp);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
